<template>
  <el-container v-title data-title="历史通知" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>消息管理</el-breadcrumb-item>
                <el-breadcrumb-item>历史通知</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="searchForm.type" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="教职通知" value="1"></el-option>
                    <el-option label="家长通知" value="2"></el-option>
                    <el-option label="成绩通知" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发送类型">
                  <el-select v-model="searchForm.sendType" placeholder="发送类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="微信" value="1"></el-option>
                    <el-option label="短信" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getNotifyRecordList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="typeName" label="类型"></el-table-column>
          <el-table-column prop="sendTypeName" label="发送类型"></el-table-column>
          <el-table-column prop="content" label="内容"></el-table-column>
          <el-table-column prop="creatorRealName" label="创建人"></el-table-column>
          <el-table-column prop="insertTime" label="创建时间"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getNotifyRecordList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        type: '',
        sendType: ''
      },
      schoolList: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getNotifyRecordList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getNotifyRecordList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getNotifyRecordList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/notifyRecord/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.searchForm.schoolId,
          type: _this.searchForm.type,
          sendType: _this.searchForm.sendType,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/NotifyRecord.vue